import moment from 'moment-timezone';

export const dateformatwithuktime = (datestring)=>
{
    const defaultTimezone = moment.tz.guess(true);
    var b = moment.tz(datestring, defaultTimezone);
    return b.format('DD/MM/YYYY HH:mm:ss');

};

export const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string
    .split(/(\s|-)/)  // Split by space or hyphen, keeping the delimiter
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize each word
    .join('');  // Join back the words including the delimiters
  };

export const normalizeWeeklyLabels=(chartData)=> {
  // Sort by fiscal week
  const sorted = [...chartData].sort((a, b) => a.fiscalWeek - b.fiscalWeek);

  // Remove leading week if its amount is 0 or it's a partial week (e.g. Sunday only)
  let startIndex = 0;
  if (sorted.length > 0 && sorted[0].amount === 0) {
    startIndex = 1;
  }

  // Re-label weeks starting from 1
  const relabeled = sorted.slice(startIndex).map((item, index) => ({
    ...item,
    localWeek: index + 1
  }));

  return relabeled;
}